import { postPoligono } from "@/shared/actions/erp";
import { PoligonoPreventa, Zone } from "@/shared/interfaces";
import { create } from "zustand";

interface InfoCoordenadas {
  open: boolean
  setOpen: (open: boolean) => void
  zone_data: Zone | null
  coordenadas?: string
  handlePostInfoZone: (data: PoligonoPreventa, sector: string) => void
  sector: string | null
  isLoading: boolean
}

export const useInfoCoordenadasStore = create<InfoCoordenadas>(set => ({
  sector: null,
  isLoading: false,
  open: false,
  setOpen(open) {
    set({ open })
  },
  zone_data: null,
  coordenadas: "",
  async handlePostInfoZone(data, sector) {
    set({ isLoading: true })
    set({ coordenadas: ""})
    set({ zone_data: null })
    const resp = await postPoligono(data).catch(err => {
      console.log(err)
      set({ isLoading: false })
      set({ open: true })
    })
    if(resp?.code !== 200) {
      set({ coordenadas: data.latitud+","+data.longitud})
      return
    }
    
    set({ isLoading: false })
    set({ zone_data: resp?.data })
    set({ sector })
    set({ open: true })
  },

}))